export const SEARCH_PARAM_TAB_NAME = "tab";
